<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>运费模板</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">

          <h2 class="title">运费模板</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handlePaperCreate">添加模板</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="模板名称">
          <el-input v-model="query.name_keyword"
                    placeholder="输入院校模板名称"
                    clearable
                    @input="fetchList()"></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="query.statuses"
                     placeholder="请选择"
                     @change="fetchList()"
                     clearable>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button type="primary"
                     size="mini"
                     @click="handleSearch">搜索</el-button>
          <el-button class="submit"
                     size="mini"
                     @click="handleFormReset('searchForm')">重置</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">模板列表</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">

          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           label="模板名称"
                           width="600"
                           align="center">
          </el-table-column>
          <el-table-column prop="creator"
                           label="创建人"
                           width="200"
                           align="center">
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="编辑时间"
                           width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.update_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="200"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToPaperEdit(scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="text"
                         @click="handleToItemsCancle(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>

</template>
<script >
import { expressTemplateList, expressTemplateDelte } from '@/api/index.js'

export default {
  data() {
    return {
      query: {
        status: '',
        name: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      results: [],
      pageTotal: 10,
    }
  },
  created() {
    this.$store.dispatch('getAdminList')
    this.fetchList()
  },
  methods: {
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    // 运费模板创建
    handlePaperCreate() {
      this.$router.push(`/freight/create`)
    },
    fetchList() {
      expressTemplateList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      // 调取列表数据
    },
    handleSelectionChange() {},
    handleToPaperEdit(row) {
      this.$router.push(`/freight/edit?id=${row.id}`)
    },
    handleToItemsCancle(row) {
      let data = {
        id: row.id,
      }
      this.$confirm(`确定要删除吗？`, '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      })
        .then(() => {
          expressTemplateDelte(data).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchList()
          })
        })
        .catch(() => {})
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    //搜索
    handleSearch() {
      this.fetchList()
    },
    //重置
    handleFormReset() {},
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 68px;
      height: 68px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
</style>